













import { Vue } from 'vue-property-decorator'
import './style.scss'

export default class UnderMaintenance extends Vue {}
